import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import { PayLinkButton } from '../ui/PayLinkButton';
import { addOpacity } from 'lib/helpers';
import { useTranslation } from 'react-i18next';

const PREFIX = 'PayorderNoteItem';

const classes = {
    value: `${PREFIX}value`
};

const StyledBox = styled(Box)(({ theme }) => ({
    borderBottom: `1px dotted ${theme.palette.divider}`,
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    justifyContent: 'space-between',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    flexWrap: 'wrap-reverse',
    '&:last-child': {
        borderBottom: 'none'
    },

    [`& .${classes.value}`]: {
        color: addOpacity(theme.palette.text.primary, 0.4)
    }
}));

interface PayOrderNoteItemProps {
    title: string;
    onClick: (index: number) => void;
    value?: string;
    index: number;
}

export const PayOrderNoteItem: React.FC<React.PropsWithChildren<PayOrderNoteItemProps>> = ({
    title,
    onClick,
    value,
    index
}) => {
    const { t } = useTranslation();

    const handleClick = React.useCallback(() => {
        onClick(index);
    }, [index, onClick]);
    return (
        <StyledBox onClick={handleClick}>
            <Box>
                <Typography>{title}</Typography>
                <Typography variant="body2" className={classes.value}>
                    {value}
                </Typography>
            </Box>
            <Box sx={{ marginLeft: 'auto' }}>
                <PayLinkButton variant="caption">
                    {value ? t('PAT_QUICKPAY_BASKET_EDIT_NOTE') : t('PAT_QUICKPAY_BASKET_ADD_NOTE')}
                </PayLinkButton>
            </Box>
        </StyledBox>
    );
};
